import { StyleSheet } from 'react-native'

export const themedCameraStyle = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: '#000',
		justifyContent: 'center'
	},
	cameraPreview: {
		flex: 1,
		backgroundColor: '#000',
	}
})
